<template>
  <div class="bonus-list page-box">
    <query-header
      ref="queryheader"
      :is-out="isOut"
      :mt4-account-options="queryAccountList"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="content-header">
        <el-input
          class="search-input"
          v-model="ruleName"
          :placeholder="phFileter('active_account')"
          clearable
        ></el-input>
        <vs-button
          class="search-btn"
          @click="searchHandle"
        >{{$t('search')}}</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead">
            <vs-th>
              {{$t('withgold.Numbering')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.mt4Account')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.RollOutAmount')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.EventName')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.SubmitTime')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.status')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.login}}
              </vs-td>
              <vs-td>
                {{tr.turnOutNum}}
              </vs-td>
              <vs-td>
                {{tr.activityName}}
              </vs-td>
              <vs-td>
                <span>{{parseTime(tr.createTime)}}</span>
              </vs-td>

              <vs-td>
                <span>{{getStatus(tr.status)}}</span>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}}&nbsp;{{total}}&nbsp;{{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getTradeHistoryAccountList } from '@/api/user';
import { queryRecordGiveGold, transferCredits, cancleCredits } from '@/api/userCenter'
import {parseTime} from "@/utils";
import { mapGetters } from 'vuex'
import initData from "@/mixins/initData";
import queryHeader from "@/components/bonusManage/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      isOut: true,
      ruleName: '',
      queryAccountList: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted(){
    this.init();
    this.getHeaderAccountList();
  },
  methods: {
    parseTime,
    phFileter(data){
      return this.$t(data)
    },
    beforeInit(){
      this.url = '/crm/reception/queryRollOutRecord'; // 赠金历史
      this.params = {
        page: this.page - 1,
        size: this.size,
        userId: this.userInfo.id,
      }
      let header = this.$refs.queryheader;
      header.currentMt4Account && (this.params.login = header.currentMt4Account);

      this.ruleName && (this.params.likeName = this.ruleName);
      header.status && (this.params.status = header.status);
      if(header.date){
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      return true;
    },
    getHeaderAccountList(){
      getTradeHistoryAccountList({
        custId: this.userInfo.id,
        type: 1,
      }).then((res) => {
        this.queryAccountList = res.data;
      })
    },
    // 0-待审核 1-已通过 2-已拒绝 3-已过期
    getStatus(status){
      let text = '';
      switch (status) {
        case 0:
          text = this.$t('withgold.withgoldOut1');
          break;
        case 1:
          text = this.$t('withgold.withgoldOut2');
          break;
        case 2:
          text = this.$t('withgold.withgoldOut3');
          break;
        case 3:
          text = this.$t('withgold.statusExpired');
          break;
      }
      return text;
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style scoped>

</style>
